import {CompanyExtensionEntity} from "@dropDesk/domain/entities/plan_extensions/company_extension.entity";
import {
    PlanExtensionSimulateHireProps
} from "@dropDesk/domain/entities/plan_extensions/plan_extension_simulate_hire.props";

export class PlanExtensionSimulateHireEntity {
    firstCycleValue!: number;
    chargedDays!: number;
    trialDaysApplied!: number;
    nextDueDate!: string;
    paymentDueDate!: string;
    extension!: CompanyExtensionEntity;
    instantDate!: string;
    period!: string;
    rawPeriod!: string;

    constructor(props: PlanExtensionSimulateHireProps) {
        Object.assign(this, props);
    }

    static fromJson(json: Record<string, any>): PlanExtensionSimulateHireEntity {
        return new PlanExtensionSimulateHireEntity({
            firstCycleValue: json['firstCycleValue'] as number,
            chargedDays: json['chargedDays'] as number,
            trialDaysApplied: json['trialDaysApplied'] as number,
            nextDueDate: json['nextDueDate'] as string,
            paymentDueDate: json['paymentDueDate'] as string,
            extension: CompanyExtensionEntity.fromJson(json['extension']),
            instantDate: json['instantDate'] as string,
            period: json['period'] as string,
            rawPeriod: json['rawPeriod'] as string
        });
    }
}
